import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "template", "index"]

  add(event) {
    event.preventDefault()
    const nextIndex = parseInt(this.indexTarget.value, 10) || 0
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, String(nextIndex))
    this.itemsTarget.insertAdjacentHTML("beforeend", html)
    this.indexTarget.value = String(nextIndex + 1)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-budget-row]")
    if (row) row.remove()
  }
}


